import React, { useState, useEffect } from 'react';
import { useClient } from 'jsonapi-react';
import { EmptyState } from '@/components/custom/empty-state';
import ChartPerformanceCard from './chartPerformanceCard';
import { FiMinimize2 } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { i18n } from '@/lib/i18n/i18n';
import { Widget, WidgetBody, WidgetDescription, WidgetHeader, WidgetTitle } from '@/components/custom/widget';

function IncomeBySubject(props) {
  const { t } = useTranslation();
  const { userId, classroomId, courseId, title, onClose } = props;
  const client = useClient();
  const [timeFilterSelected, setTimeFilterSeleted] = useState(1);
  const [taxonomies, setTaxonomies] = useState([]);
  const [topics, setTopics] = useState([]);
  const [subTopics, setSubTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const randomId = Math.floor(Math.random() * 100);

  useEffect(() => {
    fetchData('taxonomies');
  }, [timeFilterSelected, userId, classroomId, courseId]);

  useEffect(() => {
    i18n.changeLanguage(process.env.REACT_APP_LOCALE);
  }, []);

  const fetchData = async (list, taxonomyParentId) => {
    setLoading(true);
    try {
      let path;
      if (classroomId && classroomId !== 'blank') {
        path = `classrooms/${classroomId}/performance_by_taxonomy`;
      } else if (courseId && courseId !== 'blank') {
        path = `courses/${courseId}/performance_by_taxonomy`;
      } else if (userId && userId !== 'blank') {
        path = `users/${userId}/performance_by_taxonomy`;
      } else {
        path = `performance_by_taxonomy`;
      }

      const taxonomyFilter = taxonomyParentId ? `&taxonomy_parent_id=${taxonomyParentId}` : '';
      const { data } = await client.fetch(`${path}?week=${timeFilterSelected}${taxonomyFilter}`);
      if (list === 'topics') {
        setTopics(data.data);
        setSubTopics([]);
      } else if (list === 'subTopics') {
        setSubTopics(data.data);
      } else {
        setTaxonomies(data.data);
        setTopics([]);
        setSubTopics([]);
      }

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const selectTaxonomy = (taxonomy, currentList, nextList) => {
    setTaxonomies([...taxonomies]);
    if (nextList === 'subTopics') {
      topics.map(t => (t.isActive = false));
    } else if (nextList === 'topics') {
      taxonomies.map(t => (t.isActive = false));
    } else {
      subTopics.map(t => (t.isActive = false));
    }

    taxonomy.isActive = true;
    fetchData(nextList, taxonomy.id);
  };

  return (
    <Widget>
      <WidgetHeader>
        <WidgetTitle>{title || t('metrics.performanceSubject')}</WidgetTitle>
        <WidgetDescription>{t('journey.selectMatterText')}</WidgetDescription>
        {onClose && (
          <button
            className="modal__close-btn"
            onClick={onClose}
          >
            <FiMinimize2 />
          </button>
        )}
      </WidgetHeader>

      <WidgetBody>
        <div
          className="btn-group"
          role="group"
          aria-label="Escolha o tipo de evento"
        >
          <input
            type="radio"
            name="timeFilter"
            id={`ultima-semana-${randomId}`}
            autoComplete="off"
            checked={timeFilterSelected === 1}
            onChange={() => setTimeFilterSeleted(1)}
          />
          <label
            htmlFor={`ultima-semana-${randomId}`}
            className="btn btn--outline"
          >
            {t('journey.lastWeek')}
          </label>

          <input
            type="radio"
            name="timeFilter"
            id={`ultimo-mes-${randomId}`}
            autoComplete="off"
            checked={timeFilterSelected === 4}
            onChange={() => setTimeFilterSeleted(4)}
          />
          <label
            htmlFor={`ultimo-mes-${randomId}`}
            className="btn btn--outline"
          >
            {t('journey.lastmonth')}
          </label>

          <input
            type="radio"
            name="timeFilter"
            id={`tres-meses-${randomId}`}
            autoComplete="off"
            checked={timeFilterSelected === 12}
            onChange={() => setTimeFilterSeleted(12)}
          />
          <label
            htmlFor={`tres-meses-${randomId}`}
            className="btn btn--outline"
          >
            {t('journey.threeMonth')}
          </label>
        </div>

        <div className="matter-performance__container">
          <div className="matter-performance__col">
            {taxonomies &&
              taxonomies.map((taxonomy, index) => (
                <ChartPerformanceCard
                  key={index}
                  taxonomy={taxonomy}
                  onClick={() => selectTaxonomy(taxonomy, 'taxonomies', 'topics')}
                />
              ))}
          </div>

          <div className="matter-performance__col">
            {topics &&
              topics.map((taxonomy, index) => (
                <ChartPerformanceCard
                  key={index}
                  taxonomy={taxonomy}
                  onClick={() => selectTaxonomy(taxonomy, 'topics', 'subTopics')}
                />
              ))}

            {!loading && topics.length === 0 && (
              <EmptyState
                type="select"
                text={t('emptyState.selectTopicText')}
              />
            )}
          </div>

          <div className="matter-performance__col">
            {subTopics &&
              subTopics.map((taxonomy, index) => (
                <ChartPerformanceCard
                  key={index}
                  taxonomy={taxonomy}
                />
              ))}

            {!loading && subTopics.length === 0 && (
              <EmptyState
                type="select"
                text={t('emptyState.selectSubtopicText')}
              />
            )}
          </div>
        </div>
      </WidgetBody>
    </Widget>
  );
}

export default IncomeBySubject;
